import { sendBucketEvent } from 'client/javascript/heap';

export function setupHomepageRefreshExperimentBucketing() {
  sendBucketEvent('homepage_refresh_phase1_test');
}
